module.exports = __webpack_public_path__ + "static/img/prize3.d8bd74d.png";


//////////////////
// WEBPACK FOOTER
// ./src/themes/dragon/img/prize3.png
// module id = KgXW
// module chunks = 1